<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card class="signup">
                            <ion-card-header>
                                <ion-card-title color="primary">{{ $t('screens.signup-success.title') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-label>{{ $t('screens.signup-success.subtitle') }}</ion-label>
                                <ion-img :src="require('@/assets/envelope.svg')"></ion-img>
                                <ion-label>{{ $t('screens.signup-success.check-email') }}</ion-label>
                                <div class="divider"></div>
                                <ion-label class="resend">{{ $t('screens.signup-success.not-received') }}</ion-label>
                                <ion-button size="small" color="light" class="resend-button" @click="resendValidation">{{ $t('screens.signup-success.re-send') }}</ion-button>
                                <ion-note class="resent-message" v-if="resentMsg"><br />{{resentMsg}}</ion-note>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    export default {
        name: 'SignupSuccess',
        props: {
            user: String
        },
        data() {
            return {
                resentMsg: false
            }
        },
        methods: {
            resendValidation: function() {
                this.$Amplify.Auth.resendSignUp(this.user).then(data => {
                    this.$logger.debug(data);
                    this.resentMsg = this.$t('screens.signup-success.re-sent');
                }).catch(err => {
                    this.$logger.error(err);
                })
            }
        }
    }
</script>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg7.jpg') no-repeat center center / cover;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 1em;
    }

    ion-input {
        margin-left: .5em;
    }

    ion-item {
        --background: rgba(255,255,255,.6);
        margin-left: 1%;
        margin-bottom: .5em;
    }

    ion-button {
        margin-top: 1em;
    }

    ion-button.choose {
        margin-top: 0;
    }

    ion-label {
        font-family: 'Nunito', sans-serif;
        color: #fff;
        padding: .25em 0;
        display: block;
    }

    ion-card-header {
        --background: none;
    }

    ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
    }

    ion-card-title {
        --color: #333;
        font-size: 2.5em;
        font-weight: bold;
    }

    ion-col {
        padding: 0;
    }

    .content-row ion-label {
        color: #333;
        font-size: 1.2em;
    }

    ion-button ion-icon {
        margin-right: .5em;
    }

    ion-item ion-icon {
        margin-right: .25em;
    }

    .resend {
        font-size: 1em !important;
        padding-bottom: .5em;
        color: #666 !important;
    }

    .resend-button {
        margin-bottom: 1em;
    }

    .resent-message {
        font-size: .9em !important;
        color: #090 !important;
    }
</style>